import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-language-accesibility',
  templateUrl: './footer-language-accesibility.component.html',
  styleUrls: ['./footer-language-accesibility.component.scss']
})
export class FooterLanguageAccesibilityComponent {
    //#region Public Variables
    //#endregion Public Variables

    //#region Protected Variables
    //#endregion Protected Variables

    //#region Private Variables
    //#endregion Private Variables

    //#region Properties
    //#endregion Properties

    //#region Constructor
    //#endregion Constructor

    //#region Public Methods
    //#endregion Public Methods
}
